define(function(require, exports, module) {
    'use strict';
    var MenuModel = require('modules/menu/menu.model');

    module.exports = new MenuModel();
});

